import Vue from 'vue'
import {adjustColumnWidth} from '../utils/index'

Vue.directive("fit-columns", {
  update() {
  },
  bind() {
  },
  inserted(el) {
    setTimeout(() => {
      adjustColumnWidth(el);
    }, 300);
  },
  componentUpdated(el) {
    el.classList.add("r-table");
    setTimeout(() => {
      adjustColumnWidth(el);
    }, 300);
  },
  unbind() {
  },
});
